import React, { useState } from 'react'

import { connect } from 'react-redux'

import { Button } from '@driftt/tide-core'
import { showTransientNotification, tracking } from '@driftt/traffic-control'

import AutomationFeedbackModal from '../AutomationFeedbackModal'

const AutomationFeedbackButton = ({ notifications }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const handleModalSubmit = (feedback) => {
    tracking.trackEvent('automation - reports feedback', { feedback })
    setIsModalOpen(false)
    notifications.success('Your feedback has been submitted successfully')
  }

  return (
    <>
      <Button
        type="utility"
        icon="megaphone-2"
        onClick={() => setIsModalOpen(true)}
      >
        Give feedback
      </Button>
      {isModalOpen && (
        <AutomationFeedbackModal
          open={isModalOpen}
          onClose={handleModalClose}
          onSubmit={handleModalSubmit}
        />
      )}
    </>
  )
}

const mapDispatchToProps = (dispatch: any) => ({
  notifications: {
    error: (message: string): void =>
      dispatch(showTransientNotification({ message, type: 'error' })),
    success: (message: string): void =>
      dispatch(showTransientNotification({ message, type: 'success' })),
  },
})

export default connect(null, mapDispatchToProps)(AutomationFeedbackButton)
